import { z } from 'zod';
import * as FlatModels from '../../internal';

export const PageControlDetachedPageQueryResultSchema = FlatModels.EntityControlModels.EntityQueryResultSchema.extend({
  entity: z.object({
    id: z.string()
  }),
});

export type PageControlDetachedPageQueryResult = z.infer<typeof PageControlDetachedPageQueryResultSchema>;
